import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom'

// Grommet
import GridLoader from "react-spinners/GridLoader";

// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid'
import Text from '../../components/simple/text/Text'
import LocalStorageService from '../../services/LocalStorageService.js';
import AIService from '../../services/AIService';
import { replaceTerms } from '../../utils/text';


// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'
import AILinkBar from './shared/AiLinkBar.js';
import ActionBoxSmall from '../../components/compound/actionBox/ActionBoxSmall.js';

function AIIncident (props) {
  const navigate = useNavigate()
  const activeOrg = LocalStorageService.get('activeOrg');
  const apiToken = LocalStorageService.get('apiToken');
  const terms = LocalStorageService.get('terms');

  const params = useParams();

  const userId = params.userid;
  const formId = params.formId;


  const [aiSystemMessage, setAiSystemMessage] = useState('');
  const [aiPrompt, setAiPrompt] = useState('');
  const [aiResponse, setAiResponse] = useState('');
  const [aiError, setAiError] = useState(false);
  const [aiThinking, setAiThinking] = useState(false);

  const [selectedAction, setSelectedAction] = useState('summarise');
  const [availableActions, setAvailableActions] = useState({});

    const [sections, setSections] = useState([]);
    const [prompts, setPrompts] = useState([]);
    const [selectedPromptId, setSelectedPromptId] = useState(null);

  // useEffect(() => {
    
  //   let serviceUserTerm = lowercase(terms?.serviceUser || 'Service User')

  //   setAvailableActions({
  //       'summarise': 'Summarise Report',
  //       // 'lettertoparents': 'Letter to parents',
  //       'suggestions': 'Recommend Actions',
  //       'assess': 'Assess the incident report.',
  //       'informalletter':  'Draft an informal letter/email',
  //       'formalletter':  'Draft a formal letter',
  //       'suggeststaffstrategies':  'Suggest strategies for staff ',
  //       'suggestindividualstrategies':  'Suggest strategies for the ' + serviceUserTerm,
  //       'supportindividual': 'How can we best support this ' + serviceUserTerm,
  //       'moredetailonsuggestedstrategies': 'Give more detail on the suggested strategies',
  //       'postincidentlearning': 'Help me with post incident learning',
  //       'whatcanwelearn': 'What can we learn',
  //       'suggestworkshopideas': 'Suggest workshop ideas',
  //       'suggestlowlevelresponses': 'Suggest other response to low level behaviours',
  //       'suggestmediumlevelresponses': 'Suggest other response to medium level behaviours',
  //       'suggesthighlevelresponses': 'Suggest other response to high level behaviours',
  //       'possiblefunctions': 'Possible functions of behaviour'
  //     })
    
  // }, [props.terms]);

  useEffect(() => {
      getPrompts()
    }, []);
  
  
  const getPrompts = async () => {
    let response = await AIService.getPrompts(apiToken, 'Incident');
    if (response) {
      setPrompts(response);
      let newSections = [];
      for (const prompt of response) {
        if (!newSections.includes(prompt.subSection)) {
          newSections.push(prompt.subSection);
        }
      }

      if (newSections.length > 0) { 
        newSections = newSections.sort((a, b) => a?.localeCompare(b));
      }

      setSections(newSections);
    } else {
      console.error('Error getting prompts:', response?.error || 'Unknown error');    
    }
  };


  const requestIncidentAI = async (promptId) => {

    setSelectedPromptId(promptId);
    
    setAiResponse('Thinking...')
    // setAiSystemMessage('Thinking...')
    setAiThinking(true)

    const response = await AIService.askAboutIncident(apiToken, userId, formId, promptId)

    setAiThinking(false)

    if (response?.response) {
      // setAiPrompt(response?.prompt)
      setAiResponse(response.response)
      // setAiSystemMessage(response?.systemMessage)
      setAiError(false)
    } else {
      setAiResponse('')
      setAiError(true)
    }
  }

  // useEffect(() => {
  //   if (formId) {
  //       requestIncidentAI('summarise')
  //   }
  // }, [formId])



  return (
    <>
      <BreadcrumbBar
        title="AI Insights - Incident"
        path={
          <>
            <Anchor href="/">BehaviourSmart</Anchor>
            <Text color="besmartBlue" size="xsmall">
              {window.location.pathname}
            </Text>
          </>
        }
      />

      <AILinkBar />
    
      <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'small' }}
        >
          <Text margin={{ top: 'xsmall', bottom: 'xsmall' }} size="xlarge">
            Disclaimer
          </Text>
          <Text color='secondary'>
            Our AI suggestions are for informational purposes only. Users should evaluate and apply these ideas based on their expertise. Behaviour Smart is not liable for outcomes from these suggestions. Always consult a qualified professional for personalised guidance. Please do not share data with parents or other parties that you're not authorised to.
            Please report inaccurate information or issues to <Anchor color='secondary' href="https://hello.behavioursmart.co.uk/ai-feedback" target="_blank">https://hello.behavioursmart.co.uk/ai-feedback</Anchor>
          </Text>
        </Box>
      </Box>

      {(aiResponse || aiError) && <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'medium' }}
        >
        <Text size="large" style={{ width: '100%'}}>{availableActions[selectedAction]}</Text>

          <Text margin={{ top: 'xsmall' }} size="xlarge">
            {aiResponse && <>
                <GridLoader color='#ff8300' loading={aiThinking} cssOverride={{ marginRight: '20px'}} />
                {!aiThinking && <Text style={{ whiteSpace: 'pre-line' }}>{aiResponse}</Text>}
            </>}
            {aiError && <Text color='red'>There was an error processing your request. Please try again.</Text>}
          </Text>
        </Box>
      </Box>}

      {sections.map((key) => (
        <>
          <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ top: 'medium', bottom: 'medium' }}>
            <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
                 <Text size="xlarge" weight="bold" color='secondary'>
                  {key}
                </Text>
            </Box>
          </Box>

          <ResponsiveGrid
            rows={['auto']}
            columns={{
              small: ['auto'],
              medium: ['33%', '33%', '33%'],
              large: ['33%', '33%', '33%'],
              xlarge: ['33%', '33%', '33%'],
            }}
            gap="small"
          >
            { prompts?.filter(p => p.subSection === key).map((prompt) => (
                <ActionBoxSmall
                  key={prompt.id}
                  width='100%'
                  title={replaceTerms(prompt.label, terms)}
                  onClick={() => requestIncidentAI(prompt.id)}
                  active={parseInt(prompt.id) === parseInt(selectedPromptId)}
                />    
            ))}

          </ResponsiveGrid>

        </>
      ))}


      <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ top: 'medium', bottom: 'medium' }}>
        <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
           <Text size="xlarge" weight="bold" color='secondary'>
            Improve AI Insights
          </Text>
        </Box>
      </Box>


      <ResponsiveGrid
        rows={['auto']}
        columns={{
          small: ['auto'],
          medium: ['33%', '33%', '33%'],
          large: ['33%', '33%', '33%'],
          xlarge: ['33%', '33%', '33%'],
        }}
        gap="small"
      > 
        <ActionBoxSmall
          width='100%'
          title={'Report inaccurate information'}
          onClick={() => window.open('https://hello.behavioursmart.co.uk/ai-feedback', '_blank')}
        />

        <ActionBoxSmall
          width='100%'
          title={'Make a suggestion'}
          onClick={() => window.open('https://hello.behavioursmart.co.uk/ai-prompts', '_blank')}
        />

      </ResponsiveGrid>

    </>
  );
}

export default AIIncident
